import memoize from 'memoize-one'
import _ from 'lodash'

export const getPeopleWhoApplied = memoize((job, username) => {
  const list = _.get(job, 'peopleWhoApplied', [])
  if (_.get(job, 'author.username') !== username) return list

  return list.filter(el => el.userId !== username)
})
